<template>
    <div>
<!--        "<strong>{{ $_.get(activity, "refVisitor.fullname") }} </strong>" visitor was blocked by-->
<!--        <strong>{{ $_.get(activity, "actorUser.name") }}</strong>-->
        <span v-html="$t('notification.visitorBlocked', { visitor: maskedRefVisitorFullname, agent:$_.get(activity, 'actorUser.name') })"></span>
    </div>
</template>
<script>
import Vue from "vue";
import activityVisitorMaskMixin from "./activityVisitorMaskMixin";

export default Vue.extend({
    name: "VisitorBlocked",
    mixins: [activityVisitorMaskMixin],
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        maskedRefVisitorFullname() {
            return this.maskVisitorDisplayName(this.$_.get(this.activity, "refVisitor.fullname"));
        },
    },
});
</script>

<style scoped lang="scss"></style>
